import { useRef, useState } from 'react';

import { Box, useOutsideClick } from '@chakra-ui/react';
import { Button, Add as AddIcon } from '@mesh.ai/rabbit';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';

export const AddAgenda = ({ onAddAgenda }: { onAddAgenda?: (agendaText: string) => void }) => {
  const [showAddAgendaTextField, setShowAddAgendaTextField] = useState<boolean>(false);
  const [agendaValue, setAgendaValue] = useState<string>('');
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const saveAgenda = () => {
    if (agendaValue.trim() !== '') onAddAgenda?.(agendaValue);
    setShowAddAgendaTextField(false);
    setAgendaValue('');
  };

  useOutsideClick({
    ref: inputRef,
    handler: () => {
      if (showAddAgendaTextField) saveAgenda();
    },
  });

  return (
    <Box>
      {showAddAgendaTextField && (
        <AutoResizeInput
          ref={inputRef}
          isDashed
          value={agendaValue}
          onChange={(e) => setAgendaValue(e.target.value.slice(0, 255))}
          onKeyDown={(e) => {
            if (e.key === 'Enter') saveAgenda();
          }}
        />
      )}
      <Button
        iconLeft={AddIcon}
        variant="text"
        onClick={() => setShowAddAgendaTextField(true)}
        style={{ marginTop: '8px' }}
      >
        Add agenda
      </Button>
    </Box>
  );
};
